import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            阅读优势
          </h2>
          <p className="mt-2 text-sm text-foreground-500">三大核心体验，让漫画阅读变得与众不同</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuresData.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl w-5 h-5 flex items-center justify-center`} />
              </div>
              <h3 className="mt-5 font-heading text-lg md:text-xl text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}